import { useAuth } from "../contexts/AuthContext";
import AdminDashboard from "./dashboards/AdminDashboard";
import ManagerDashboard from "./dashboards/ManagerDashboard";
import PractitionerDashboard from "./dashboards/PractitionerDashboard";
import * as theme from '../theme';
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

const canAccess = (userRole, allowedRoles) => userRole && allowedRoles.includes(userRole);

export default function Dashboard() {
  const { currentUser, loading } = useAuth();

  if (loading || !currentUser) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <div style={theme.Container.flexColumnContainer}>
      {canAccess(currentUser.role, ["admin"]) && <AdminDashboard />}
      {canAccess(currentUser.role, ["manager"]) && <ManagerDashboard />}
      {canAccess(currentUser.role, ["practitioner"]) && <PractitionerDashboard />}
    </div>
  );
}